/*
 * DateNight Story — Produkt-Landingpage.
 * Minimales, isoliertes First-Party-JS ohne externe Library/Framework.
 * Zwei Custom Elements, je nach Section optional vorhanden:
 *
 *  <dnp-hero-gallery>  (sections/datenight-story-product-hero.liquid)
 *    Tauscht per Klick auf ein Thumbnail das Hero-Hauptbild aus
 *    (src/srcset/alt) - kein Page Reload, kein Slider-Framework.
 *
 *  <dnp-trailer>  (sections/datenight-story-trailers.liquid)
 *    Rendert initial nur ein Poster-Bild + Play-Button. Das eigentliche
 *    <video>-Markup liegt bis zum Klick reglos in einem <template>
 *    (Browser laden/parsen Inhalte von <template> nicht - keine
 *    Video-Bytes vor der Nutzerinteraktion). Erst beim Klick wird der
 *    Template-Inhalt in den DOM geklont und .play() aufgerufen (User-
 *    Geste, daher ohne "muted" erlaubt) - kein Autoplay beim Laden.
 *
 * Beide folgen demselben Guard-Muster wie das theme-eigene
 * assets/product-form.js ("if (!customElements.get(...))"), um Fehler bei
 * mehrfachem Laden des Scripts zu vermeiden.
 */
(() => {
  if (!customElements.get('dnp-hero-gallery')) {
    customElements.define(
      'dnp-hero-gallery',
      class DnpHeroGallery extends HTMLElement {
        connectedCallback() {
          this.mainImage = this.querySelector('.dnp-hero-image');
          this.thumbButtons = Array.from(this.querySelectorAll('.dnp-gallery-thumb'));
          if (!this.mainImage || this.thumbButtons.length === 0) return;

          this.thumbButtons.forEach((button) => {
            button.addEventListener('click', this.onThumbClick.bind(this, button));
          });
        }

        onThumbClick(button) {
          const fullSrc = button.getAttribute('data-full-src');
          const fullAlt = button.getAttribute('data-full-alt');
          const fit = button.getAttribute('data-fit');
          if (!fullSrc) return;

          this.mainImage.removeAttribute('srcset');
          this.mainImage.removeAttribute('sizes');
          this.mainImage.src = fullSrc;
          if (fullAlt) this.mainImage.alt = fullAlt;

          // Bild-Buehne bleibt immer 4:5 (siehe CSS) - nur der object-fit-
          // Modus wechselt: "cover" fuer das dedizierte, nativ 4:5-grosse
          // Hero-Bild, "contain" fuer alle regulaeren product.media-Bilder
          // (1:1-Marketing-Motive mit Rand-Elementen, die sonst
          // angeschnitten wuerden).
          this.mainImage.classList.toggle('dnp-hero-image--contain', fit === 'contain');

          this.thumbButtons.forEach((otherButton) => {
            otherButton.removeAttribute('aria-current');
          });
          button.setAttribute('aria-current', 'true');
        }
      }
    );
  }

  if (!customElements.get('dnp-trailer')) {
    customElements.define(
      'dnp-trailer',
      class DnpTrailer extends HTMLElement {
        connectedCallback() {
          this.playButton = this.querySelector('.dnp-trailer-poster');
          this.template = this.querySelector('template');
          if (!this.playButton || !this.template) return;

          this.playButton.addEventListener('click', this.onPlay.bind(this));
        }

        onPlay() {
          const fragment = this.template.content.cloneNode(true);
          const video = fragment.querySelector('video');

          this.playButton.remove();
          this.template.remove();
          this.appendChild(fragment);

          const insertedVideo = this.querySelector('video');
          if (insertedVideo) {
            insertedVideo.setAttribute('controls', '');
            const playResult = insertedVideo.play();
            if (playResult && typeof playResult.catch === 'function') {
              playResult.catch(() => {});
            }
          } else if (video) {
            video.setAttribute('controls', '');
          }
        }
      }
    );
  }
})();
